export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8470.46bb0333.jpg";